module.exports = __webpack_public_path__ + "static/img/main4.cdab523.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/programme/main4.png
// module id = cpMx
// module chunks = 1